import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import LoginModal from '../components/LoginModal';
import AdminCommentModeration from '../components/AdminCommentModeration';
import type { RootState } from '../store/store';

const AdminContainer = styled.div`
    box-sizing: border-box;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 20px;
    background: linear-gradient(135deg, #f8f9fa, #ffffff);
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
`;

const Title = styled.h1`
    text-align: center;
    color: #333;
    margin-bottom: 30px;
    font-size: 28px;
    font-weight: 700;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
`;

const Message = styled.p`
    text-align: center;
    color: #666;
    font-size: 16px;
    margin-top: 20px;
`;

const Admin: React.FC = () => {
    const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);
    const [isModalOpen, setIsModalOpen] = useState(!isAuthenticated);

    useEffect(() => {
        if (!isAuthenticated) {
            setIsModalOpen(true);
        }
    }, [isAuthenticated]);

    const isAdmin = Boolean(isAuthenticated && user?.isAdmin);

    return (
        <AdminContainer>
            <Title>Správa používateľov</Title>

            {isAuthenticated && !isAdmin && <Message>Nemáte administrátorské práva.</Message>}

            {!isAuthenticated && (
                <LoginModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onLogin={() => setIsModalOpen(false)}
                />
            )}

            {/* The moderation component requires a verified second factor before loading users. */}
            {isAdmin && <AdminCommentModeration />}
        </AdminContainer>
    );
};

export default Admin;
